import { ModalOptions } from '../enum';

export type WebhookState = 'pending' | 'active' | 'inactive' | 'failed';

export interface Webhook {
  webhookId: string;
  description: string; // Matches 'name' in UI conceptually, but backend calls it description
  url: string;
  state: WebhookState;
  events: string[];
  headers?: Record<string, string>;
  secret?: string;
  createdAt?: string;
  updatedAt?: string;

  // UI computed props (service will map these)
  name?: string;
  enabled?: boolean;
  logs?: WebhookLog[];
}

export interface WebhookLog {
  webhookId: string;
  logId: string;
  eventType: string;
  payload?: string;
  statusCode: number;
  latency: number;
  success: boolean;
  timestamp: string;
  error?: string;
}

export interface WebhookTestResult {
  latency: number;
  statusCode: number;
  errorMessage?: string;
  errorDetails?: {
    raw_body: any;
    content_type?: string;
    headers?: Record<string, string>;
  };
}

export enum WebhookEventType {
  TRANSCRIPTION_COMPLETED = 'transcription.completed',
  AI_PROCESSING_COMPLETED = 'ai_processing.completed',
}

export interface WebhookModalPayload {
  option: ModalOptions;
  data?: Partial<Webhook>;
}
